import theme from '@styles/theme';
export default {
  container: {
    width: '100%',
    height: 'auto',
    backgroundColor: theme.rawColors.beige500,
    p: '80px 40px',
    h2: {
      p: ['0 24px 40px', '0 24px 40px', '0 24px 40px', '0 115px 48px 115px']
    }
  },
  projectsContainer: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: ['repeat(1, minmax(0, 1fr))', 'repeat(1, minmax(0, 1fr))', 'repeat(2, minmax(0, 1fr))', 'repeat(3, minmax(0, 1fr))', 'repeat(4, minmax(0, 1fr))'],
    gridTemplateRows: 'repeat(auto-fill, minmax(0, 1fr))'
  }
};